import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';
import { P } from 'stile-shared/src/components/2020/common/Primitives';

import { PageLayout } from 'templates/2020/PageLayout';
import { SEO } from 'templates/2020/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Mississippi Science Standards Teacher Guide"
      description="Complete teacher guide for Mississippi's new science standards"
      slug={props.location.pathname}
    />
  );
}

function MississippiTeacherGuidePage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="Mississippi College- and Career-Readiness Standards for Middle School Science"
        subtitle="Teacher Guide"
        id="TEACHING_GUIDE"
        redirectUrl="https://stileapp.com/go/ms-teacher-guide"
        hideMeetingTime={true}
        image={
          <StaticImage
            src="../../../../stile-shared/assets/images/states/mississippi/teacher-guide.png"
            alt="Aerial view of the Mississippi River winding through sandbars at dusk"
          />
        }
      >
        <P>
          This guide helps teachers navigate the changes to the Mississippi College- and
          Career-Readiness Standards. Implement the MCCRS with ease, using real-world science and
          global issues in your classroom.
        </P>
      </ResourceAccessBlock>

      <CtaBlock />
    </PageLayout>
  );
}

export default MississippiTeacherGuidePage;
